export const customerPersonalDataToModel = personalData => {
  return {
    name: personalData.name,
    surname: personalData.surname,
    mobilePhone: personalData.mobilePhone,
  }
}

export const modelToPersonalDataForm = personalData => {
  return {
    name: personalData.name ? personalData.name : '',
    surname: personalData.surname ? personalData.surname : '',
    mobilePhone: personalData.mobilePhone ? personalData.mobilePhone : '',
  }
}



// WEBPACK FOOTER //
// ./src/domain/model/customer/customer.mapper.ts